import { createRouter } from '@tanstack/react-router';
import NotFound from './components/not-found/not-found';
import { routeTree } from './routeTree.gen';

export function getRouter() {
  return createRouter({
    routeTree,
    scrollRestoration: true,
    defaultPreload: 'intent',
    // e.g. a product or collection loader throwing notFound()
    defaultNotFoundComponent: NotFound
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
